import { cn } from '../../utils/cn';
import { motionSafe } from '../../utils/focus';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        motionSafe('animate-pulse'),
        'bg-primary/10 rounded-md',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
